import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Image } from 'ui';

import { StepFive } from './StepFive';
import { StepFour } from './StepFour';
import { StepOne } from './StepOne';
import { StepThree } from './StepThree';
import { StepTwo } from './StepTwo';

const lastStepIndex = 4;

export interface GuideProps {
  open: boolean;
  onClose: () => void;
  guideIllustrations: {
    holdPhone: string;
    phoneAngle: string;
    instantFeedback: string;
  };
}

export const Guide = ({ open, onClose, guideIllustrations }: GuideProps) => {
  const [currentStep, setCurrentStep] = useState(0);

  const handleClose = () => {
    onClose();

    // Adding a slight delay to offset the fade animation
    setTimeout(() => {
      setCurrentStep(0);
    }, 200);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        {currentStep === 0 ? (
          <StepOne>
            <Image src={guideIllustrations.holdPhone} />
          </StepOne>
        ) : null}
        {currentStep === 1 ? (
          <StepTwo>
            <Image src={guideIllustrations.phoneAngle} />
          </StepTwo>
        ) : null}
        {currentStep === 2 ? (
          <StepThree>
            <Image src={guideIllustrations.instantFeedback} />
          </StepThree>
        ) : null}
        {currentStep === 3 ? <StepFour /> : null}
        {currentStep === 4 ? <StepFive /> : null}
      </DialogContent>
      <DialogActions sx={{ justifyContent: currentStep === lastStepIndex ? 'flex-end' : 'space-between', padding: 2 }}>
        {currentStep === lastStepIndex ? (
          <Button onClick={handleClose} variant="secondary">
            Finish tour
          </Button>
        ) : (
          <>
            <Button onClick={handleClose} variant="text">
              End tour
            </Button>
            <Button onClick={() => setCurrentStep(currentStep + 1)} variant="secondary">
              Next
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};
